import {
    RESTORE_PERSISTED_STATE,
    REFRESH_PERSISTED_STATE
    } from './actionTypes';

export function restorePersistedState(persistedState)
{
    return {
        type: RESTORE_PERSISTED_STATE,
        payload: persistedState || {}
    }
}

export function refreshPersistedStateAction(stateLocation, value)
{
    return {
        type: REFRESH_PERSISTED_STATE,
        payload:
        {
            stateLocation,
            value,
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/persistence-strategy-cookie/src/actions/actions.js